import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { ROUTES } from '@/constants/routes'

import AuthLayout from '@/components/layouts/AuthLayout'
import LoginLayout from '@/components/layouts/LoginLayout'
import WithBottomNavLayout from '@/components/layouts/WithBottomNavLayout'

import DashboardPage from '@/app/pages/dashboard'
import DocumentsPage from '@/app/pages/documents'
import EmiSchedulePage from '@/app/pages/emiSchedule/page'
import HistoryPage from '@/app/pages/history/page'
import LandingPage from '@/app/pages/landing'
import LoanDetailPage from '@/app/pages/LoanDetail/page'
import LoginPage from '@/app/pages/login'
import LogoutPage from '@/app/pages/logout'
import NotFoundPage from '@/app/pages/not-found'
import OtpPage from '@/app/pages/otp'
import PayPage from '@/app/pages/pay/page'
import PaymentPage from '@/app/pages/payment/page'
import ProfilePage from '@/app/pages/profile'

export default function App() {
  return (
    <BrowserRouter basename={import.meta.env.VITE_BASE_PATH || '/cashloan'}>
      <AuthLayout>
        <Routes>
          <Route element={<LandingPage />} path={ROUTES.LANDING} />
          <Route
            element={
              <WithBottomNavLayout>
                <DashboardPage />
              </WithBottomNavLayout>
            }
            path={ROUTES.DASHBOARD}
          />
          <Route element={<LoanDetailPage />} path={ROUTES.LOAN_DETAIL} />
          <Route
            element={
              <WithBottomNavLayout>
                <HistoryPage />
              </WithBottomNavLayout>
            }
            path={ROUTES.HISTORY}
          />
          <Route element={<PayPage />} path={ROUTES.PAY} />
          <Route element={<PaymentPage />} path={ROUTES.PAYMENT} />
          <Route element={<EmiSchedulePage />} path={ROUTES.EMI_SCHEDULE} />
          <Route
            element={
              <LoginLayout>
                <LoginPage />
              </LoginLayout>
            }
            path={ROUTES.LOGIN}
          />
          <Route
            element={
              <LoginLayout>
                <OtpPage />
              </LoginLayout>
            }
            path={ROUTES.OTP}
          />
          <Route element={<DocumentsPage />} path={ROUTES.DOCUMENTS} />
          <Route
            element={
              <WithBottomNavLayout>
                <ProfilePage />
              </WithBottomNavLayout>
            }
            path={ROUTES.PROFILE}
          />
          <Route element={<LogoutPage />} path={ROUTES.LOGOUT} />
          <Route element={<NotFoundPage />} path='/404' />
          <Route element={<NotFoundPage />} path='*' />
        </Routes>
      </AuthLayout>
    </BrowserRouter>
  )
}
